export const MIDIChannelEvents = {
  noteOff: 0x08,
  noteOn: 0x09,
  noteAftertouch: 0x0a,
  controller: 0x0b,
  programChange: 0x0c,
  channelAftertouch: 0x0d,
  pitchBend: 0x0e,
} as const
